module.exports = __webpack_public_path__ + "img/icon-recommend-active.28baac2.webp";